import { WFile } from "@/types/file";
import request from ".";
import { isApp } from "../utils/checkTool";
import { cleanToApp } from "../utils/cleanData";
import { App, AppAdd } from "@/types/app";
import { CommonListParams } from "types/common";
import { isString, isStringEmpty } from 'utils/checkTool';

const APP_URL = '/wms/sys';

const APP_APIS = {
  appList: APP_URL + '/appVersion/list',
  appAdd: APP_URL + '/appVersion/add',
  htmlToPdf: APP_URL + '/htmlToPdf'
}

export const appList = (params?: CommonListParams) => {
  return new Promise<CommonListParams<Array<App>>>((resolve, reject) => {
    if (params && params.body && !isString(params.body)) {
      return reject(10012)
    }
    request<Array<App>, string>(APP_APIS.appList, { params })
      .then(({ body, pagination }) => resolve({
        body,
        pagination,
      }))
      .catch((err) => reject(err));
  });
};

export const appAdd = (appInfo: AppAdd) => {
  if ((isStringEmpty(appInfo.desc) && !isString(appInfo.desc)) || (isStringEmpty(appInfo.fileId) && !isString(appInfo.fileId))) {
    return Promise.reject(10012)
  }
  return request<App, AppAdd>(APP_APIS.appAdd, { params: { body: appInfo } })
    .then(res => {
      if (isApp(res.body)) {
        return Promise.resolve(cleanToApp(res.body))
      } else {
        return Promise.reject(10013)
      }
    })
    .catch(err => Promise.reject(err))
};

export interface HTMLInfo {
  html: string;
  fileName?: string;
  multiPage: boolean;
};

export const htmlToPdf = (data: HTMLInfo) => {
  return new Promise<string>((resolve, reject) => {
    request<string, HTMLInfo>(APP_APIS.htmlToPdf, { params: { body: data } })
      .then(res => resolve(res.body))
      .catch(err => reject(err))
  })
}